import { useMemo, useSyncExternalStore } from 'react';
import { FeatureFlagKeys } from '@/services/featureFlag';
import { allClips } from '@/stores/clip';
import featureFlagStore from '@/stores/featureFlagStore';

export const useAllVisibleClips = () => {
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const allClipsStoreData = useSyncExternalStore(allClips.subscribe, allClips.getSnapshot);
  const allVisibleClips = useMemo(() => {
    if (!featureFlags[FeatureFlagKeys.Use_CL_Copy_Clip_To_Test_AiEdits]) {
      // Hide clips that are marked as AI edits testing clips
      return allClipsStoreData.filter(clip => {
        return clip.asset_metadata.is_copied_for_ai_edits_testing !== true;
      });
    }
    return allClipsStoreData;
  }, [allClipsStoreData, featureFlags]);

  return { allVisibleClips };
};
